import { render, staticRenderFns } from "./FormQuestionList.vue?vue&type=template&id=036e33d1&scoped=true"
import script from "./FormQuestionList.vue?vue&type=script&lang=js"
export * from "./FormQuestionList.vue?vue&type=script&lang=js"
import style0 from "./FormQuestionList.vue?vue&type=style&index=0&id=036e33d1&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e33d1",
  null
  
)

export default component.exports